exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._25YYezSAM_fFOyUCqzO8pK {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  height: 400px;\n}\n", ""]);

// exports
exports.locals = {
	"loading": "_25YYezSAM_fFOyUCqzO8pK"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"importLoaders":1}!./~/postcss-loader/lib?{"config":{"path":"/workspace/config/postcss.config.js"}}!./src/components/profile/loading-events/index-module.css
// module id = 3614
// module chunks = 14